/**
 * n ms 동안 대기하는 promise
 * time 대기 시간
 */
export const wait = (time: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, time);
  });
